module.exports = __webpack_public_path__ + "static/favicon-9494c0b0f676065b2d6dc7c113216894.ico";